import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "sonner";
import { DashboardData, DashboardState } from "../../types/dashboardType";
import dashboardApis from "../../api/dashboardApis";

export const fetchDashboardData = createAsyncThunk<
  DashboardData,
  {
    branchCode: string;
    classId?: number;
    staffId?: number;
  },
  { rejectValue: string }
>("dashboard/fetchDashboardData", async (payload, thunkAPI) => {
  const { branchCode, classId, staffId } = payload;

  const data = await dashboardApis.fetchDashboardData(branchCode, {
    classId,
    staffId,
  });
  if (data) return data;
  return thunkAPI.rejectWithValue("Failed to fetch dashboard data");
});

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchDashboardData.fulfilled,
        (state, action: PayloadAction<DashboardData>) => {
          state.loading = false;
          state.data = action.payload;
        },
      )
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch data";
        toast.error(state.error);
      });
  },
});

export default dashboardSlice.reducer;
